export const PREFERENCIAS_INPUT_TYPE = {
  TOGGLE: 'TOGGLE',
  SELECT: 'SELECT',
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
};

export const PREFERENCIAS_CATEGORIAS = [
  {
    key: 'telaDeVenda',
    title: 'Tela de Venda',
    description: '',
  },
  {
    key: 'impressao',
    title: 'Impressão',
    description: '',
  },
]

export const PREFERENCIAS_DEFAULTS = [
  {
    key: 'exibirValorBruto',
    categoriaKey: 'telaDeVenda',
    type: PREFERENCIAS_INPUT_TYPE.TOGGLE,
    title: 'Exibir Valor Bruto',
    description: '',
    defaultValue: true,
  },
  {
    key: 'exibirDescontoValor',
    categoriaKey: 'telaDeVenda',
    type: PREFERENCIAS_INPUT_TYPE.TOGGLE,
    title: 'Exibir Desconto em Valor',
    description: '',
    defaultValue: true,
  },
  {
    key: 'exibirDescontoPercentual',
    categoriaKey: 'telaDeVenda',
    type: PREFERENCIAS_INPUT_TYPE.TOGGLE,
    title: 'Exibir Desconto em Percentual (%)',
    description: '',
    defaultValue: true,
  },
  {
    key: 'exibirAcrescimoValor',
    categoriaKey: 'telaDeVenda',
    type: PREFERENCIAS_INPUT_TYPE.TOGGLE,
    title: 'Exibir Acréscimo em Valor',
    description: '',
    defaultValue: true,
  },
  {
    key: 'exibirAcrescimoPercentual',
    categoriaKey: 'telaDeVenda',
    type: PREFERENCIAS_INPUT_TYPE.TOGGLE,
    title: 'Exibir Acréscimo em Percentual (%)',
    description: '',
    defaultValue: true,
  },
  {
    key: 'exibirEstoque',
    categoriaKey: 'telaDeVenda',
    type: PREFERENCIAS_INPUT_TYPE.TOGGLE,
    title: 'Exibir Estoque',
    description: '',
    defaultValue: true,
  },
  {
    key: 'exibirCodigoBarras',
    categoriaKey: 'telaDeVenda',
    type: PREFERENCIAS_INPUT_TYPE.TOGGLE,
    title: 'Exibir Código de Barras',
    description: '',
    defaultValue: true,
  },
  {
    key: 'exibirAmbiente',
    categoriaKey: 'telaDeVenda',
    type: PREFERENCIAS_INPUT_TYPE.TOGGLE,
    title: 'Exibir Ambiente',
    description: '',
    defaultValue: true,
  },
  {
    key: 'impressaoVenda',
    categoriaKey: 'impressao',
    type: PREFERENCIAS_INPUT_TYPE.SELECT,
    title: 'Impressão na Venda',
    description: '',
    options: [
      { label: 'Padrão', value: 'PADRAO' },
      { label: 'Ambiente', value: 'AMBIENTE' },
    ],
    defaultValue: 'PADRAO',
  },
];